module.exports = __webpack_public_path__ + "img/shib.849acec6.svg";